import { ExceptionApiNotFound } from '~/data/exceptions/ExceptionApiNotFound'

export const useApplicationStore = defineStore('applicationStore', {
  state: () => ({
    _bankCodeList: [] as IUserBankCodeListSelect.ResponseItem[],
    _categoryPermissionList: {
      cOMPANY: [],
      pERSONAL: [],
    } as ICategoryApplyPermissionSelect.ResponseItem,
    _categoryList: [] as ICategoryListSelect.ResponseItem[],
    _entryStatus: {
      status: null,
      content: '',
      submittedAt: '',
    } as IArtistEntryStatusSelect.ResponseItem,
  }),
  getters: {
    bankCodeList: (state) => state._bankCodeList,
    categoryPermissionList: (state) => state._categoryPermissionList,
    categoryList: (state) => state._categoryList,
    entryStatus: (state) => state._entryStatus,
  },
  actions: {
    async setBankCodeList() {
      const $nuxt = useNuxtApp()
      const response = await $nuxt.$apiService.userApi.selectBankCodeList()
      this._bankCodeList = response.items
    },
    async setCategoryPermissionList() {
      const $nuxt = useNuxtApp()
      const response =
        await $nuxt.$apiService.categoryApi.selectCategoryApplyPermission()
      this._categoryPermissionList = response.success
    },
    async setCategoryList() {
      const $nuxt = useNuxtApp()
      const response = await $nuxt.$apiService.categoryApi.selectCategoryList()
      this._categoryList = response.success
    },
    async setEntryStatus() {
      try {
        const $nuxt = useNuxtApp()
        const response = await $nuxt.$apiService.artistApi.selectEntryStatus()
        this._entryStatus = response
      } catch (error: any) {
        if (error instanceof ExceptionApiNotFound) {
          return
        }

        throw error
      }
    },
  },
})
